import { useState } from 'react';
import { Link } from 'react-router-dom';

import { apiRequest } from '../api/client.js';
import { Alert } from '../components/Alert.js';
import { Field } from '../components/Field.js';
import { AuthLayout } from './AuthLayout.js';

export function ForgotPasswordPage(): React.JSX.Element {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event: React.SyntheticEvent): Promise<void> => {
    event.preventDefault();
    setSubmitting(true);
    try {
      await apiRequest('/auth/forgot-password', { method: 'POST', body: { email } });
    } finally {
      /*
       * The same outcome is shown whether or not the address is registered,
       * matching the API. Reporting "no such account" here would leak exactly
       * what the endpoint is careful not to (ADR 0010).
       */
      setSubmitted(true);
      setSubmitting(false);
    }
  };

  return (
    <AuthLayout
      title="Reset your password"
      subtitle="We will email you a link to choose a new one."
      footer={
        <>
          Remembered it? <Link to="/login">Sign in</Link>
        </>
      }
    >
      {submitted ? (
        <Alert tone="success">
          If that address has a Connaro account, a reset link is on its way. It expires in one hour
          and can be used once.
        </Alert>
      ) : (
        <form
          onSubmit={(event) => {
            void handleSubmit(event);
          }}
          noValidate
        >
          <Field
            label="Email address"
            type="email"
            value={email}
            onChange={setEmail}
            autoComplete="email"
            required
          />
          <button type="submit" className="btn btn--primary btn--block" disabled={submitting}>
            {submitting ? 'Sending…' : 'Send reset link'}
          </button>
        </form>
      )}
    </AuthLayout>
  );
}
